import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  // bestSellerOne,
  // bestSellerTwo,
  // bestSellerThree,
  // bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
  earings1,
  earings2,
  earings3,
  earings4,
  earings5,
  earings6,
  earings7,
  earings8,
  earings9,
  earings10,
  earings11,
  earings12,
  earings13,
  earings14,
  necklace1,
  necklace2,
  necklace3,
  ring1,
  ring2,
  ring3,
  ring4,
  chain1,
  chain2,
  chain3,
  // earringVideo,
  // earringVideo2,
  necklace4,
  dollar1,
  dollar2,
  dollar3,
  dollar4,
 // chain4,
  bangles1,
  bangles2,
  bangles3,
  bangles4,
  // ringVideo,
  // chainVideo,
  necklace6,
  necklace14,
  necklace15,
  // necklace13,
  necklace10,
  necklace11,
  necklace12,
  necklace7,
  necklace8,
  necklace9,
  necklace5,
  necklace16,
  ring1_Image3,
  ring1_Image2,
  ring1_Image1,
  bombayNeckles3_Image1,
  bombayNeckles3_Image2,
  stud2_Image1,
  stud2_Image2,
  stud2_Image3,
  stud80_Image1,
  stud80_Image2,
  stud81_Image1,
  stud81_Image2,
  stud81_Image3,
  stud82_Image1,
  stud82_Image2,
  stud82_Image3,
  stud83_Image1,
  stud83_Image2,
  stud83_Image3,
  stud84_Image1,
  stud84_Image2,
  stud84_Image3,
  stud85_Image1,
  stud85_Image2,
  stud85_Image3,
  stud86_Image1,
  stud86_Image2,
  stud86_Image3,
  stud87_Image1,
  stud87_Image2,
  stud87_Image3,
  stud88_Image1,
  stud88_Image2,
  stud88_Image3,
  stud89_Image1,
  stud89_Image2,
  stud89_Image3,
  stud90_Image1,
  stud90_Image2,
  stud90_Image3,
  stud91_Image1,
  stud91_Image2,
  stud91_Image3,
  stud80_Image3,
  stud92_Image1,
  stud92_Image2,
  stud92_Image3,
  stud93_Image1,
  stud93_Image2,
  stud93_Image3,
  stud94_Image1,
  stud94_Image2,
  stud94_Image3,
  stud95_Image1,
  stud95_Image2,
  stud95_Image3,
  // stud96_Image1,
  // stud96_Image2,
  // stud96_Image3,
  stud97_Image1,
  stud97_Image2,
  stud97_Image3,
  jimikiDropsEaringStuds54_Image1,
  jimikiDropsEaringStuds54_Image2,
  jimikiDropsEaringStuds54_Image3,
  jimikiDropsEaringStuds55_Image1,
  jimikiDropsEaringStuds55_Image2,
  jimikiDropsEaringStuds55_Image3,
  jimikiDropsEaringStuds56_Image1,
  jimikiDropsEaringStuds56_Image2,
  jimikiDropsEaringStuds56_Image3,
  jimikiDropsEaringStuds57_Image1,
  jimikiDropsEaringStuds57_Image2,
  jimikiDropsEaringStuds57_Image3,
  jimikiDropsEaringStuds58_Image1,
  jimikiDropsEaringStuds58_Image2,
  jimikiDropsEaringStuds58_Image3,
  jimikiDropsEaringStuds59_Image1,
  jimikiDropsEaringStuds59_Image2,
  jimikiDropsEaringStuds59_Image3,
  jimikiDropsEaringStuds60_Image1,
  jimikiDropsEaringStuds60_Image2,
  jimikiDropsEaringStuds60_Image3,
  jimikiDropsEaringStuds61_Image1,
  jimikiDropsEaringStuds61_Image2,
  jimikiDropsEaringStuds61_Image3,
  jimikiDropsEaringStuds62_Image1,
  jimikiDropsEaringStuds62_Image2,
  jimikiDropsEaringStuds62_Image3,
  jimikiDropsEaringStuds63_Image1,
  jimikiDropsEaringStuds63_Image2,
  jimikiDropsEaringStuds63_Image3,
  jimikiDropsEaringStuds64_Image1,
  jimikiDropsEaringStuds64_Image2,
  jimikiDropsEaringStuds64_Image3,
  jimikiDropsEaringStuds66_Image1,
  jimikiDropsEaringStuds66_Image2,
  jimikiDropsEaringStuds66_Image3,
  jimikiDropsEaringStuds67_Image1,
  jimikiDropsEaringStuds67_Image2,
  jimikiDropsEaringStuds67_Image3,
  jimikiDropsEaringStuds68_Image1,
  jimikiDropsEaringStuds68_Image2,
  jimikiDropsEaringStuds68_Image3,
  jimikiDropsEaringStuds69_Image1,
  jimikiDropsEaringStuds69_Image2,
  jimikiDropsEaringStuds69_Image3,
  jimikiDropsEaringStuds70_Image1,
  jimikiDropsEaringStuds70_Image2,
  jimikiDropsEaringStuds70_Image3,
  jimikiDropsEaringStuds71_Image1,
  jimikiDropsEaringStuds71_Image2,
  jimikiDropsEaringStuds71_Image3,
  jimikiDropsEaringStuds72_Image1,
  jimikiDropsEaringStuds72_Image2,
  jimikiDropsEaringStuds72_Image3,
  jimikiDropsEaringStuds73_Image1,
  jimikiDropsEaringStuds73_Image2,
  jimikiDropsEaringStuds73_Image3,
  // jimikiDropsEaringStuds74_Image1,
  // jimikiDropsEaringStuds74_Image2,
  // jimikiDropsEaringStuds74_Image3,
  jimikiDropsEaringStuds75_Image1,
  jimikiDropsEaringStuds75_Image2,
  jimikiDropsEaringStuds75_Image3,
  jimikiDropsEaringStuds76_Image1,
  jimikiDropsEaringStuds76_Image2,
  jimikiDropsEaringStuds76_Image3,
  jimikiDropsEaringStuds77_Image1,
  jimikiDropsEaringStuds77_Image2,
  jimikiDropsEaringStuds77_Image3,
  jimikiDropsEaringStuds78_Image1,
  jimikiDropsEaringStuds78_Image2,
  jimikiDropsEaringStuds78_Image3,
  fancyStuds79_image1,
  fancyStuds79_image2,
  fancyStuds79_image3,
} from "../assets/images/index";

// =================== NavBarList Start here ====================

export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  // {
  //   _id: 1006,
  //   title: "Chit",
  //   link: "/Chit",
  // },
  // {
  //   _id: 1006,
  //   title: "FD",
  //   link: "/fixeddeposit",
  // },
  // {
  //   _id: 1005,
  //   title: "Goldloan",
  //   link: "/goldLoan",
  // },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: [spfOne],
    category: "Anklets",
    productName: "Anklet",
    price: "35.00",
    color: "White",
    size: "6 inch",
    weight: "20 gram",
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: "202",
    img: [newArrFour],
    category: "Anklets",
    productName: "Anklets",
    price: "180.00",
    color: "weight",
    size: "12 inch",
    weight: "70 gram",
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: "203",
    img: [spfThree],
    category: "Toe Rings",
    productName: "Toe Rings",
    price: "25.00",
    color: "Mixed",
    size: "11 inch",
    weight: "52 gram",
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: "204",
    img: [spfFour],
    category: "Anklets",
    productName: "Anklets",
    price: "220.00",
    color: "Black",
    size: "6.9 inch",
    weight: "81 gram",
    des: "fixed price at whole sale rate with less wastage",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: earings1,
    category: "Earrings",
    productName: "Earings1",
    price: "35.00",
    color: "Gold and White",
    size: "6 inch",
    weight: "37 gram",
    badge: true,
    wastage: 12,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1002,
    img: earings2,
    category: "Earrings",
    productName: "Anklets",
    price: "180.00",
    color: "Gray",
    size: "5.5 inch",
    weight: "80 gram",
    wastage: 12,
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1003,
    img: earings3,
    category: "Earrings",
    productName: "Earings",
    price: "25.00",
    color: "Mixed",
    size: "7 inch",
    weight: "67 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1004,
    img: earings4,
    category: "Earrings",
    productName: "Earings",
    price: "220.00",
    color: "Black",
    size: "9 inch",
    weight: "78 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },

  {
    _id: 1009,
    img: necklace1,
    category: "Necklace",
    productName: "Necklace",
    price: "44.00",
    color: "Black",
    size: "8 inch",
    weight: "126 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1010,
    img: necklace2,
    category: "Necklace",
    productName: "Necklace3",
    price: "250.00",
    color: "Black",
    size: "12.6 inch",
    weight: "99 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1011,
    img: necklace3,
    category: "Necklace",
    productName: "Necklace",
    price: "80.00",
    color: "Mixed",
    size: "8 inch",
    weight: "-",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1012,
    img: ring1,
    category: "Rings",
    productName: "Ring",
    price: "60.00",
    color: "Mixed",
    size: "5 inch",
    weight: "34 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1013,
    img: ring2,
    category: "Rings",
    productName: "Ring for men",
    price: "60.00",
    color: "Mixed",
    size: "7 inch",
    weight: "23 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },

  {
    _id: 1014,
    img: ring3,
    category: "Rings",
    productName: "Ring",
    price: "250.00",
    color: "Black",
    size: "4 inch",
    weight: "95 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1015,
    img: ring4,
    category: "Rings",
    productName: "Ring 4",
    price: "60.00",
    color: "Mixed",
    size: "5.5 inch",
    weight: "87 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1016,
    img: chain1,
    category: "Chain",
    productName: "chain",
    price: "250.00",
    color: "Black",
    size: "6 inch",
    weight: "53 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },

  {
    _id: 1018,
    img: chain2,
    category: "Bracelets",
    productName: "Bracelets",
    price: "44.00",
    color: "Black",
    size: "6.6 inch",
    weight: "34 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1019,
    img: chain3,
    category: "Bracelets",
    productName: "Bracelets",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1020,
    img: newArrThree,
    category: "Bracelets",
    productName: "Bracelets",
    price: "80.00",
    color: "Mixed",
    size: "9.2 inch",
    weight: "78 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1021,
    img: spfThree,
    category: "Bracelets",
    productName: "Bracelets",
    price: "25.00",
    color: "Mixed",
    size: "7.3 inch",
    weight: "54 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1022,
    img: spfFour,
    category: "Anklets",
    productName: "Anklets",
    price: "220.00",
    color: "Black",
    size: "1 inch",
    weight: "133 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },

  {
    _id: 1024,
    img: spfOne,
    category: "Anklets",
    productName: "Anklet2",
    price: "35.00",
    color: "Black and White",
    size: "12 inch",
    weight: "144 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1025,
    img: spfTwo,
    category: "Anklets",
    productName: "Anklets",
    price: "180.00",
    color: "Gray",
    size: "11.4 inch",
    weight: "153 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1026,
    img: spfThree,
    category: "Toe Rings",
    productName: "Toe Rings",
    price: "25.00",
    color: "Mixed",
    size: "6 inch",
    weight: "53 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1027,
    img: spfFour,
    category: "Anklets",
    productName: "Anklets",
    price: "220.00",
    color: "Black",
    size: "67.9inch",
    weight: "223 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1032,
    img: newArrOne,
    category: "Braclets",
    productName: "Bracelets",
    price: "44.00",
    color: "Black",
    size: "6 inch",
    weight: "59 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1033,
    img: newArrTwo,
    category: "Braclets",
    productName: "Bracelets",
    price: "250.00",
    color: "Black",
    size: "6.1 inch",
    weight: "52 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1034,
    img: newArrThree,
    category: "Braclets",
    productName: "Bracelets",
    price: "80.00",
    color: "Mixed",
    size: "7.5 inch",
    weight: "83 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1035,
    img: newArrFour,
    category: "Braclets",
    productName: "Bracelets",
    price: "60.00",
    color: "Mixed",
    size: "6 inch",
    weight: "69 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1036,
    img: newArrTwo,
    category: "Braclets",
    productName: "Bracelets",
    price: "60.00",
    color: "Mixed",
    size: "11.2 inch",
    weight: "232 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1037,
    img: newArrFour,
    category: "Braclets",
    productName: "Bracelets",
    price: "60.00",
    color: "Mixed",
    size: "9 inch",
    weight: "138 gram",
    badge: false,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1038,
    img: newArrTwo,
    category: "Braclets",
    productName: "Braclets",
    price: "250.00",
    color: "Black",
    size: "7.3 inch",
    weight: "223 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1040,
    img: newArrOne,
    category: "Braclets",
    productName: "Bracelets",
    price: "44.00",
    color: "Black",
    size: "9 inch",
    weight: "123 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1041,
    img: newArrTwo,
    category: "Braclets",
    productName: "Bracelets",
    price: "250.00",
    color: "Black",
    size: "8 inch",
    weight: "163 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1042,
    img: newArrThree,
    category: "Braclets",
    productName: "Bracelets",
    price: "80.00",
    color: "Mixed",
    size: "6.4 inch",
    weight: "122 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1043,
    img: spfThree,
    category: "Toe Rings",
    productName: "Toe Rings",
    price: "25.00",
    color: "Mixed",
    size: "6 inch",
    weight: "53 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1044,
    img: spfFour,
    category: "Braclets",
    productName: "Bracelets",
    price: "220.00",
    color: "Black",
    size: "6 inch",
    weight: "53 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
  {
    _id: 1046,
    img: spfOne,
    category: "Anklets",
    productName: "Anklet3",
    price: "35.00",
    color: "Black and White",
    size: "6 inch",
    weight: "66 gram",
    badge: true,
    des: "fixed price at whole sale rate with less wastage",
  },
];
// =================== PaginationItems End here =================

// =================== CategoryItems Start here ===============
export let earrings = [
  {
    _id: "98",
    img: [earings1, earings2, earings3],
    video: "https://youtube.com/shorts/MXeiOwNk1io?si=VasD8jQIRB9nBW_i",
    category: "Earring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
  
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "99",
    img: [earings4, earings5, earings6],
    video: "",
    category: "Earring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "100",
    img: [earings7, earings8, earings9],
    video: "",
    category: "Earring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "101",
    img: [earings10, earings11, earings12],
    video: "",
    category: "Earring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "102",
    img: [earings12, earings13, earings14],
    video: "",
    category: "Earring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let necklace = [
  {
    _id: "103",
    img: [necklace1, necklace2, necklace3],
    video: "",
    category: "Necklace",
    productName: "",
    price: "",
    weight: "",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "104",
    img: [necklace4, necklace5, necklace6],
    video: "",
    category: "Necklace",
    productName: "",
    price: "",
    weight: "",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "105",
    img: [necklace7, necklace8, necklace9],
    video: "",
    category: "Necklace",
    productName: "",
    price: "",
    weight: "",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "106",
    img: [necklace10, necklace11, necklace12],
    video: "",
    category: "Necklace",
    productName: "",
    price: "",
    weight: "-",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "107",
    img: [necklace14, necklace15, necklace16],
    category: "Necklace",
    productName: "",
    price: "78500.00",
    weight: "-",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let rings = [
  {
    _id: "108",
    img: [ring1, ring2, ring3],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "109",
    img: [ring4, ring3, ring2],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    size: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "110",
    img: [ring3, ring2, ring2],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "111",
    img: [ring1, ring2, ring3],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "112",
    img: [ring1, ring2, ring3],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];

export let dollar = [
  {
    _id: "113",
    img: [dollar1, dollar2, dollar3],
    category: "Dollar",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "114",
    img: [dollar3, dollar4, dollar4],
    category: "Dollar",
    productName: "",
    price: "",
    weight: "",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "115",
    img: [dollar4, dollar2, dollar3],
    category: "Dollar",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "116",
    img: [dollar4, dollar2, dollar3],
    category: "Dollar",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let chain = [
  {
    _id: "117",
    img: [chain1, chain2, chain3],
    category: "Chain",
    productName: "",
    video: "",
    price: "",
    weight: "",
    wastage: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  }
];
export let bangle = [
  {
    _id: "118",
    img: [bangles1, bangles2, bangles3],
    category: "Bangle",
    productName: "",
    price: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "119",
    img: [bangles4, bangles2, bangles3],
    category: "Bangle",
    productName: "",
    price: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "120",
    img: [bangles1, bangles2, bangles3],
    category: "Bangle",
    productName: "",
    price: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "121",
    img: [bangles2, bangles1, bangles3],
    category: "",
    productName: "",
    price: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let ringList = [
  {
    _id: "1",
    img: [ring1_Image1, ring1_Image2, ring1_Image3],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
   

    


  },
  {
    _id: "108",
    img: [ring1, ring2, ring3],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "109",
    img: [ring4, ring3, ring2],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    size: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "110",
    img: [ring3, ring2, ring2],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "111",
    img: [ring1, ring2, ring3],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "112",
    img: [ring1, ring2, ring3],
    video: "",
    category: "Ring",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let studList = [
  {
    _id: "2",
    img: [stud2_Image1, stud2_Image2, stud2_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "80",
    img: [stud80_Image1, stud80_Image2, stud80_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "81",
    img: [stud81_Image1, stud81_Image2, stud81_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "82",
    img: [stud82_Image1, stud82_Image2, stud82_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "83",
    img: [stud83_Image1, stud83_Image2, stud83_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "84",
    img: [stud84_Image1, stud84_Image2, stud84_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "85",
    img: [stud85_Image1, stud85_Image2, stud85_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "86",
    img: [stud86_Image1, stud86_Image2, stud86_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "87",
    img: [stud87_Image1, stud87_Image2, stud87_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "88",
    img: [stud88_Image1, stud88_Image2, stud88_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "89",
    img: [stud89_Image1, stud89_Image2, stud89_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "90",
    img: [stud90_Image1, stud90_Image2, stud90_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "91",
    img: [stud91_Image1, stud91_Image2, stud91_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "92",
    img: [stud92_Image1, stud92_Image2, stud92_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "93",
    img: [stud93_Image1, stud93_Image2, stud93_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {

    _id: "94",
    img: [stud94_Image1, stud94_Image2, stud94_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "95",
    img: [stud95_Image1, stud95_Image2, stud95_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  // {
  //   _id: "96",
  //   img: [stud96_Image1, stud96_Image2, stud96_Image3],
  //   video: "",
  //   category: "Stud",
  //   productName: "",
  //   price: "",
  //   wastage: "",
  //   weight: "",
  //   des: "",
    // stockType: "",
    // designName: "",
    // onboardDate: "",
    // goldRateWhileOnboard: "",
    // pgjWastage: "",
  // },
  {
    _id: "97",
    img: [stud97_Image1, stud97_Image2, stud97_Image3],
    video: "",
    category: "Stud",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  }
];
export let bombayNecklesList = [
  {
    _id: "3",
    img: [bombayNeckles3_Image1, bombayNeckles3_Image2, bombayNeckles3_Image2],
    video: "https://youtu.be/j_SjIhB5RnY?si=YJyUtosAcFzX1e7W",
    category: "BombayNeckles",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let machineChainList = [
  {
    _id: "4",
    img: [bombayNeckles3_Image1, bombayNeckles3_Image2, bombayNeckles3_Image2],
    video: "",
    category: "Machine chain",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let brasletList = [
  {
    _id: "8",
    img: [bombayNeckles3_Image1, bombayNeckles3_Image2, bombayNeckles3_Image2],
    video: "",
    category: "Machine chain",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let jimikiDropsEaringStudsList = [
  {
    _id: "54",
    img: [jimikiDropsEaringStuds54_Image1, jimikiDropsEaringStuds54_Image2, jimikiDropsEaringStuds54_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "55",
    img: [jimikiDropsEaringStuds55_Image1, jimikiDropsEaringStuds55_Image2, jimikiDropsEaringStuds55_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "56",
    img: [jimikiDropsEaringStuds56_Image1, jimikiDropsEaringStuds56_Image2, jimikiDropsEaringStuds56_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "57",
    img: [jimikiDropsEaringStuds57_Image1, jimikiDropsEaringStuds57_Image2, jimikiDropsEaringStuds57_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "58",
    img: [jimikiDropsEaringStuds58_Image1, jimikiDropsEaringStuds58_Image2, jimikiDropsEaringStuds58_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "59",
    img: [jimikiDropsEaringStuds59_Image1, jimikiDropsEaringStuds59_Image2, jimikiDropsEaringStuds59_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "60",
    img: [jimikiDropsEaringStuds60_Image1, jimikiDropsEaringStuds60_Image2, jimikiDropsEaringStuds60_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "61",
    img: [jimikiDropsEaringStuds61_Image1, jimikiDropsEaringStuds61_Image2, jimikiDropsEaringStuds61_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "62",
    img: [jimikiDropsEaringStuds62_Image1, jimikiDropsEaringStuds62_Image2, jimikiDropsEaringStuds62_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "63",
    img: [jimikiDropsEaringStuds63_Image1, jimikiDropsEaringStuds63_Image2, jimikiDropsEaringStuds63_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "64",
    img: [jimikiDropsEaringStuds64_Image1, jimikiDropsEaringStuds64_Image2, jimikiDropsEaringStuds64_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  // {
  //   _id: "65",
  //   img: [jimikiDropsEaringStuds65_Image1, jimikiDropsEaringStuds65_Image2, jimikiDropsEaringStuds65_Image3],
  //   video: "",
  //   category: "JimikiDropsEaringStuds",
  //   productName: "",
  //   price: "",
  //   wastage: "",
  //   weight: "",
  //   des: "",
    // stockType: "",
    // designName: "",
    // onboardDate: "",
    // goldRateWhileOnboard: "",
    // pgjWastage: "",
  // },
  {
    _id: "66",
    img: [jimikiDropsEaringStuds66_Image1, jimikiDropsEaringStuds66_Image2, jimikiDropsEaringStuds66_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "67",
    img: [jimikiDropsEaringStuds67_Image1, jimikiDropsEaringStuds67_Image2, jimikiDropsEaringStuds67_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "68",
    img: [jimikiDropsEaringStuds68_Image1, jimikiDropsEaringStuds68_Image2, jimikiDropsEaringStuds68_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "69",
    img: [jimikiDropsEaringStuds69_Image1, jimikiDropsEaringStuds69_Image2, jimikiDropsEaringStuds69_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "70",
    img: [jimikiDropsEaringStuds70_Image1, jimikiDropsEaringStuds70_Image2, jimikiDropsEaringStuds70_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "71",
    img: [jimikiDropsEaringStuds71_Image1, jimikiDropsEaringStuds71_Image2, jimikiDropsEaringStuds71_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "72",
    img: [jimikiDropsEaringStuds72_Image1, jimikiDropsEaringStuds72_Image2, jimikiDropsEaringStuds72_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "73",
    img: [jimikiDropsEaringStuds73_Image1, jimikiDropsEaringStuds73_Image2, jimikiDropsEaringStuds73_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  // {
  //   _id: "74",
  //   img: [jimikiDropsEaringStuds74_Image1, jimikiDropsEaringStuds74_Image2, jimikiDropsEaringStuds74_Image3],
  //   video: "",
  //   category: "JimikiDropsEaringStuds",
  //   productName: "",
  //   price: "",
  //   wastage: "",
  //   weight: "",
  //   des: "",
    // stockType: "",
    // designName: "",
    // onboardDate: "",
    // goldRateWhileOnboard: "",
    // pgjWastage: "",
  // },
  {
    _id: "75",
    img: [jimikiDropsEaringStuds75_Image1, jimikiDropsEaringStuds75_Image2, jimikiDropsEaringStuds75_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "76",
    img: [jimikiDropsEaringStuds76_Image1, jimikiDropsEaringStuds76_Image2, jimikiDropsEaringStuds76_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "77",
    img: [jimikiDropsEaringStuds77_Image1, jimikiDropsEaringStuds77_Image2, jimikiDropsEaringStuds77_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
  {
    _id: "78",
    img: [jimikiDropsEaringStuds78_Image1, jimikiDropsEaringStuds78_Image2, jimikiDropsEaringStuds78_Image3],
    video: "",
    category: "JimikiDropsEaringStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  }

];
export let fanceDollarList = [
  {
    _id: "8",
    img: [bombayNeckles3_Image1, bombayNeckles3_Image2, bombayNeckles3_Image2],
    video: "",
    category: "FanceDollar",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export let fancyStudsList = [
  {
    _id: "79",
    img: [fancyStuds79_image1, fancyStuds79_image2, fancyStuds79_image3],
    video: "",
    category: "FancyStuds",
    productName: "",
    price: "",
    wastage: "",
    weight: "",
    des: "",
    stockType: "",
    designName: "",
    onboardDate: "",
    goldRateWhileOnboard: "",
    pgjWastage: "",
  },
];
export const allItems = [
  ...necklace,
  ...earrings,
  ...chain,
  ...dollar,
  ...bangle,
  ...bombayNecklesList,
  ...ringList,
  ...studList,
  ...machineChainList,
  ...brasletList,
  ...jimikiDropsEaringStudsList,
  ...fanceDollarList,
  ...fancyStudsList,
];
